import { Dialog } from '@headlessui/react';
import { IconTimesDefault } from '@iwoca/icons';

import { CardUsageLimits } from './CardUsageLimits';
import { MakePayment } from './MakePayment';
import { ReplaceCard } from './replaceCard/ReplaceCard';
import { StatementsAndDocuments } from './StatementsAndDocuments';

export type DrawerContent =
    | 'makePayment'
    | 'accountPreferences'
    | 'statementsAndDocuments'
    | 'cardUsageLimits'
    | 'replaceCard'
    | null;

type DrawerSliderProps = {
    content: DrawerContent;
    onClose: () => void;
};

export const DrawerSlider = ({ content, onClose }: DrawerSliderProps) => {
    const renderDrawerContent = () => {
        switch (content) {
            case 'makePayment':
                return <MakePayment />;
            case 'accountPreferences':
                return null;
            case 'statementsAndDocuments':
                return <StatementsAndDocuments />;
            case 'cardUsageLimits':
                return <CardUsageLimits />;
            case 'replaceCard':
                return <ReplaceCard onClose={onClose} />;
            default:
                return null;
        }
    };

    const isOpen = content !== null;
    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 z-[1001] bg-black opacity-60" />
            )}
            <Dialog static open={isOpen} onClose={onClose}>
                <Dialog.Panel
                    className={
                        isOpen
                            ? 'fixed right-0 top-0 z-[1021] flex h-screen w-full flex-col bg-structure-100 text-primary-10 transition-transform duration-100 ease-out min-m:w-[28rem]'
                            : 'fixed right-0 top-0 z-[1021] flex h-screen w-full translate-x-full flex-col bg-structure-100 text-primary-10 transition-transform duration-100 ease-out min-m:w-[28rem]'
                    }
                >
                    <div className="min-m:pt-r flex items-center justify-end px-l pt-s min-m:px-xl">
                        <button
                            onClick={onClose}
                            className="cursor-pointer border-0 bg-transparent p-0"
                            // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                            aria-label="Close drawer"
                        >
                            <IconTimesDefault width={24} height={24} />
                        </button>
                    </div>
                    <div className="flex-1 overflow-y-auto px-l pb-l min-m:px-xl min-m:pb-xl">
                        {renderDrawerContent()}
                    </div>
                </Dialog.Panel>
            </Dialog>
        </>
    );
};
